import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useMarket } from "../lib/store";
import { useBasket } from "../lib/basket";
import { useSubscribe } from "../lib/socket";
import { fmt, compact, pct, tone, signed } from "../lib/format";
import { Panel, PageHeader, th, td, btnGhost, Empty } from "../components/Panel";

export default function Futures() {
  const [rows, setRows] = useState([]);
  const [seg, setSeg] = useState("NSE_FO");
  const ticks = useMarket((s) => s.ticks);
  const { openOrder, addMeta } = useMarket();
  const addLeg = useBasket((s) => s.add);
  useEffect(() => {
    api.get("/fno/futures").then((r) => {
      setRows(r.data);
      addMeta(Object.fromEntries(r.data.map((x) => [x.instrument_key, { ...x, instrument_type: "FUT", exchange: x.segment.split("_")[0] }])));
    });
  }, [addMeta]);
  const shown = rows.filter((r) => r.segment === seg).slice(0, 150);
  useSubscribe(shown.flatMap((r) => (seg === "MCX_FO" ? [r.instrument_key] : [r.instrument_key, r.underlying_key])));
  const days = (e) => Math.ceil((new Date(`${e}T15:30:00+05:30`) - Date.now()) / 86400e3);
  return (
    <div className="p-4 lg:p-6" data-testid="futures-page">
      <PageHeader title="Futures">
        {[["NSE_FO", "NSE"], ["BSE_FO", "BSE"], ["MCX_FO", "MCX"]].map(([v, l]) => (
          <button key={v} data-testid={`futures-seg-${l}`} onClick={() => setSeg(v)} className={`${btnGhost} ${seg === v ? "border-primary text-primary" : ""}`}>{l}</button>))}
      </PageHeader>
      <Panel>
        {!shown.length ? <Empty>Loading futures…</Empty> : (
          <div className="overflow-auto thin-scroll max-h-[calc(100vh-220px)]">
            <table className="w-full" data-testid="futures-table">
              <thead className="border-b border-border sticky top-0 bg-card"><tr>
                {["Contract", "LTP", "Chg%", "OI", "Spot", "Basis", "Expiry", ""].map((h, i) => <th key={i} className={`${th} ${i && i < 6 ? "text-right" : ""}`}>{h}</th>)}</tr></thead>
              <tbody>{shown.map((r) => {
                const t = ticks[r.instrument_key];
                const s = ticks[r.underlying_key];
                const basis = t?.ltp && s?.ltp && seg !== "MCX_FO" ? t.ltp - s.ltp : null;
                const d = days(r.expiry);
                return (
                  <tr key={r.instrument_key} className="border-b border-border/60 hover:bg-accent/40" data-testid={`future-row-${r.underlying_symbol}`}>
                    <td className={`${td} font-medium`}>{r.trading_symbol}</td>
                    <td className={`${td} num text-right ${tone(t?.ch)}`}>{t?.ltp ? fmt(t.ltp) : "—"}</td>
                    <td className={`${td} num text-right ${tone(t?.chp)}`}>{t?.ltp ? pct(t?.chp) : "—"}</td>
                    <td className={`${td} num text-right`}>{compact(t?.oi)}</td>
                    <td className={`${td} num text-right text-muted-foreground`}>{seg === "MCX_FO" ? "—" : fmt(s?.ltp)}</td>
                    <td className={`${td} num text-right ${tone(basis)}`}>{basis == null ? "—" : signed(basis)}</td>
                    <td className={td}>{r.expiry}{d <= 3 && r.next && <span className="ml-2 text-[9.5px] font-semibold text-amber-500 border border-amber-500/40 rounded px-1" title="Near expiry — consider rolling to next month">ROLLOVER</span>}</td>
                    <td className={`${td} text-right`}><span className="flex justify-end gap-1">
                      <button data-testid={`future-buy-${r.instrument_key}`} className="h-6 w-7 rounded bg-up text-white text-[10px] font-bold" onClick={() => openOrder({ key: r.instrument_key, side: "BUY" })}>B</button>
                      <button data-testid={`future-sell-${r.instrument_key}`} className="h-6 w-7 rounded bg-down text-white text-[10px] font-bold" onClick={() => openOrder({ key: r.instrument_key, side: "SELL" })}>S</button>
                      <button data-testid={`future-basket-${r.instrument_key}`} className="h-6 w-7 rounded border border-border text-[11px] font-bold" onClick={() => addLeg({ key: r.instrument_key, side: "BUY" })}>+</button></span></td>
                  </tr>);
              })}</tbody>
            </table>
          </div>)}
      </Panel>
    </div>
  );
}
